import { render, staticRenderFns } from "./Reverse.vue?vue&type=template&id=07cf569f"
import script from "./Reverse.vue?vue&type=script&lang=js"
export * from "./Reverse.vue?vue&type=script&lang=js"
import style0 from "./Reverse.vue?vue&type=style&index=0&id=07cf569f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports